import { supabase } from "@/lib/supabase";

export interface MatchResultEdit {
  id: string;
  group_id: string;
  match_id: number;
  event_id: string | null;
  edited_by: string | null;
  previous_scorea: number | null;
  previous_scoreb: number | null;
  previous_winner: "A" | "B" | "Draw" | null;
  new_scorea: number | null;
  new_scoreb: number | null;
  new_winner: "A" | "B" | "Draw" | null;
  created_at: string;
  dispute_reason?: string | null;
  disputed_at?: string | null;
  disputed_by?: string | null;
}

export async function fetchMatchResultHistory(
  matchId: number,
  groupId?: string
): Promise<MatchResultEdit[]> {
  let query = supabase
    .from("match_result_edits")
    .select("*")
    .eq("match_id", matchId)
    .order("created_at", { ascending: false });

  if (groupId) {
    query = query.eq("group_id", groupId);
  }

  const { data, error } = await query;
  if (error) throw error;
  return (data ?? []) as MatchResultEdit[];
}

export async function fileMatchResultDispute(
  matchId: number,
  groupId: string,
  eventId: string | null,
  userId: string,
  reason?: string
): Promise<void> {
  const { data: match, error: matchError } = await supabase
    .from("matches")
    .select("scorea, scoreb, winner")
    .eq("id", matchId)
    .single();

  if (matchError) throw matchError;

  const { error } = await supabase.from("match_result_edits").insert({
    group_id: groupId,
    match_id: matchId,
    event_id: eventId,
    edited_by: userId,
    previous_scorea: match.scorea,
    previous_scoreb: match.scoreb,
    previous_winner: match.winner,
    new_scorea: match.scorea,
    new_scoreb: match.scoreb,
    new_winner: match.winner,
    dispute_reason: reason ?? "Player disputed the official result",
    disputed_at: new Date().toISOString(),
    disputed_by: userId,
  });

  if (error) throw error;
}
